import React from 'react';
export const ProgressionSection = () => {
  return <section className="w-full bg-gray-50 py-10 px-4" data-id="element-294">
      <div className="max-w-4xl mx-auto" data-id="element-295">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-296">
          La Progression Silencieuse Qui Mène à l'Amputation
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-sm mb-8" data-id="element-297">
          <p className="text-gray-700 mb-6 italic" data-id="element-298">
            "J'ai exactement 18 mois pour agir. Après, il est souvent trop
            tard."
          </p>
          <p className="text-gray-700 mb-6" data-id="element-299">
            Voici comment la neuropathie diabétique progresse, étape par étape :
          </p>
          <div className="mb-8" data-id="element-300">
            <div className="bg-blue-600 text-white py-2 px-4 rounded-t-md" data-id="element-301">
              <h3 className="font-bold" data-id="element-302">
                Étape 1 : Les Premiers Signaux (Mois 1-6)
              </h3>
            </div>
            <div className="border border-blue-200 border-t-0 p-4 rounded-b-md" data-id="element-303">
              <ul className="list-disc pl-5 space-y-2 text-gray-700" data-id="element-304">
                <li data-id="element-305">Fourmillements nocturnes occasionnels</li>
                <li data-id="element-306">"Sensation d'avoir marché sur des clous"</li>
                <li data-id="element-307">Réveils à cause de "brûlures" aux pieds</li>
                <li data-id="element-308">La plupart des patients ignorent ces symptômes</li>
              </ul>
            </div>
          </div>
          <div className="mb-8" data-id="element-309">
            <div className="bg-blue-600 text-white py-2 px-4 rounded-t-md" data-id="element-310">
              <h3 className="font-bold" data-id="element-311">
                Étape 2 : L'Engourdissement S'installe (Mois 6-12)
              </h3>
            </div>
            <div className="border border-blue-200 border-t-0 p-4 rounded-b-md" data-id="element-312">
              <ul className="list-disc pl-5 space-y-2 text-gray-700" data-id="element-313">
                <li data-id="element-314">Perte progressive de sensibilité</li>
                <li data-id="element-315">Difficulté à sentir la température de l'eau du bain</li>
                <li data-id="element-316">Équilibre perturbé, premiers risques de chutes</li>
                <li data-id="element-317">Sensation de "marcher sur du coton"</li>
              </ul>
            </div>
          </div>
          <div className="mb-8" data-id="element-318">
            <div className="bg-yellow-600 text-white py-2 px-4 rounded-t-md" data-id="element-319">
              <h3 className="font-bold" data-id="element-320">
                Étape 3 : La Zone de Danger (Mois 12-18)
              </h3>
            </div>
            <div className="border border-yellow-200 border-t-0 p-4 rounded-b-md" data-id="element-321">
              <ul className="list-disc pl-5 space-y-2 text-gray-700" data-id="element-322">
                <li data-id="element-323">Engourdissement complet des extrémités</li>
                <li data-id="element-324">
                  Blessures non détectées (clous, cailloux, chaussures trop
                  serrées)
                </li>
                <li data-id="element-325">Infections qui ne guérissent pas</li>
                <li data-id="element-326">Premiers signes de gangrène</li>
              </ul>
            </div>
          </div>
          <div className="mb-8" data-id="element-327">
            <div className="bg-red-600 text-white py-2 px-4 rounded-t-md" data-id="element-328">
              <h3 className="font-bold" data-id="element-329">
                Étape 4 : Le Point de Non-Retour (Mois 18+)
              </h3>
            </div>
            <div className="border border-red-200 border-t-0 p-4 rounded-b-md" data-id="element-330">
              <ul className="list-disc pl-5 space-y-2 text-gray-700" data-id="element-331">
                <li data-id="element-332">Nécrose des tissus</li>
                <li data-id="element-333">Infection généralisée</li>
                <li data-id="element-334">Amputation comme seule solution</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-335">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-336">
            Pourquoi Cela Arrive-t-il ?
          </h3>
          <div className="flex flex-col md:flex-row gap-6" data-id="element-337">
            <div className="md:w-1/2" data-id="element-338">
              <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Illustration des dommages nerveux" className="w-full h-auto rounded-md shadow-sm mb-4" data-id="element-339" />
            </div>
            <div className="md:w-1/2" data-id="element-340">
              <p className="text-gray-700 mb-4" data-id="element-341">
                Le glucose élevé dans votre sang est comme du verre pilé qui
                circule dans vos veines. Chaque jour, il endommage un peu plus
                la gaine protectrice de vos nerfs.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-342">
                Quand cette gaine est détruite, le nerf meurt. Et un nerf mort
                ne revient jamais.
              </p>
              <p className="text-gray-700 font-bold" data-id="element-343">
                C'est pourquoi le temps est critique. Plus vous attendez, plus
                les dommages s'accumulent.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};